import { useModalContext } from "../../../contexts/ModalContext"
import cross from '../../../assets/images/svg/cross'

const ExitIconButton = () => {

    const { closeModal } = useModalContext()

    return (
        <i id="exitIcon" className="iconImgBtn right-2" onClick={closeModal}>
            {cross}
        </i>
    )
}

export default ExitIconButton